import { app } from '../../bootstrap/core';
import { statusState } from './status.state';
import { statusComponent } from './status.component';
import { StatusService } from './status.service';
import './components/progressPie/progressPie';
import './components/progressBar/progressBar';
import './components/shipmentStatus/shipmentStatus';

import './verify/verify';

angular
  .module(app.name)
  .config(statusState)
  .service('statusService', StatusService)
  .component(statusComponent.name, statusComponent);



// WEBPACK FOOTER //
// ./src/app/components/status/status.js